<template>
  <div class="feedbackResult-box">
    <div class="cell-list">
      <div class="cell" @click="cellClick">
        <div class="label">处置结果<span class="xinghao">*</span></div>
        <div class="content">
          <span>{{ disposalResult.name }}</span>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
      <div v-if="disposalResult.id === 30" class="cell" @click="reasonHandle">
        <div class="label">
          不予受理原因
          <span>*</span>
        </div>
        <div class="content">
          <span>{{ reasonItem.name }}</span>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
      <div v-else>
        <div class="cell" @click="returnMethodPickerHandle()">
          <div class="label">
            退款方式
            <span>*</span>
          </div>
          <div class="content">
            <span :class="{'qinguxanze': selectReturnMethod.name === '请选择'}">{{ selectReturnMethod.name }}</span>
            <van-icon class="arrow" name="arrow" />
          </div>
        </div>
        <div class="cell">
          <div class="label">
            退款金额
            <span>*</span>
          </div>
          <div class="money-box">
            <span class="qianfuhao">￥</span>
            <van-field
            class="moneyCell"
              v-model="refundAmount"
              :disabled="disposalResult.id == 40"
              placeholder="请输入"
              type="number"
            />
            <!-- <van-field
            input-align="right"
            :disabled="disposalResult.id == 40"
              v-model="refundAmount"
              rows="1"
              autosize
              type="textarea"
              placeholder="请输入"
            /> -->
          </div>
        </div>
  
        <!-- 如果是部分退款选择是否退回商品 -->
        <div v-if="disposalResult.id === 1 && detail && detail.refundChannel !== 0 && detail.finalRefundTypes !== 2" class="cell">
          <div class="label">
            是否需要寄回商品
            <span>*</span>
          </div>
          <div class="content">
            <van-radio-group v-model="radio" direction="horizontal">
              <van-radio name="1">
                是
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-radio>
              <van-radio name="0">
                否
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="add">
      <p class="title">补充说明<span class="xinghao">*</span></p>
      <van-field
          autosize
          type="textarea"
          ref="AddressTextarea" 
          v-model="content" 
          class="textarea"
          maxlength="500"
        />
      <div class="tip">{{ content.length }}/500</div>
    </div>
    <div class="upload-box">
      <!-- <<p class="title">相关凭证</p> -->
      <upload v-if="detail" :fileBizType="30" @fileuploadData="fileUploadData" :sourceId="detail.basicId"></upload>
      <!-- <van-uploader v-model="fileList" multiple @delete="delPreImg()">
        <img
          class="camera-icon"
          src="https://img0.baidu.com/it/u=561041293,259965800&fm=26&fmt=auto&gp=0.jpg"
          alt
        />
      </van-uploader>-->
    </div>
    <div class="onSubmit" @click="onSubmit">确定</div>

    <!-- 处置结果弹框 -->
    <poplist
      ref="disposalResultPicker"
      @select="selectDisposalResult"
      @close="selectDisposalResult"
      :datalist="popupList"
      :header="'选择处置结果'"
    />
    <!-- 不予受理弹框 -->
    <poplist
      ref="picker"
      @select="selectReason"
      @close="selectReason"
      :datalist="reasonList"
      :header="'选择不予受理原因'"
    />
    <!-- 退货方式弹出框 -->
    <poplist
      ref="returnMethodPicker"
      @select="selectReturnMethodHandle"
      @close="selectReturnMethodHandle"
      :datalist="returnMethodList"
      :header="'退款方式'"
    />
    <!-- <van-popup v-model="returnMethodPickerShow" position="bottom" :style="{ height: '50%' }">
      <van-area
        @confirm="returnMethodConfirm"
        @cancel="returnMethodPickerShow = false"
        value="40"
        :area-list="returnMethodList"
        :columns-num="1"
      />
    </van-popup>-->
    <!-- <div class="btn" @click="onSubmit">提交</div> -->
  </div>
</template>

<script>
    import upload from '../components/upload';
    import api from '@/service/modules/refund.js';
    import poplist from '../components/listPopup';
    import { mapActions } from 'vuex';

    export default {
        components: { upload, poplist },
        watch: {
          refundAmount: {
            handler (newVal, oldVal) {
                if (newVal > this.shoppingAmount) {
                    this.refundAmount = this.shoppingAmount
                    this.$toast({
                        message: '超过最大金额！'
                    });
                }
                // 实时修改input框的宽度
                let node = document.querySelectorAll('.moneyCell .van-field__control')
                let inputWidth
                const html = getComputedStyle(window.document.documentElement)['font-size']
                const htmlFontSize = +html.slice(0, html.indexOf('px'))
                console.log('htmlFontSize', htmlFontSize);
                  if (this.refundAmount.length > 0) {
                    console.log('this.refundAmount.length * 14', this.refundAmount.length * 14);
                    // inputWidth = (this.refundAmount.length * 10) / htmlFontSize
                    inputWidth = 8 / 37.5 * this.refundAmount.length
                    console.log('inputWidth', inputWidth);
                  } else {
                    inputWidth = 48 / 37.5
                  }
                  node[0].setAttribute("style",`width: ${inputWidth}rem;`)
            }
          }
        },
        data () {
            return {
                radio: '', // 是否寄回商品
                activeIcon: require('../../../../assets/refund/checkbox-select.png'),
                inactiveIcon: require('../../../../assets/refund/checkbox-defalut.png'),
                reasonItem: {
                    name: '请选择'
                },
                reasonList: [], // 不予受理原因
                returnMethodPickerShow: false,
                content: '',
                fileList: [], // 上传文件列表
                refundAmount: 0, // 退款金额
                show: false,
                popupList: [
                    { name: '全额退款', id: 40 },
                    { name: '部分退款', id: 1 },
                    { name: '不予受理', id: 30 }
                ], // 处置结果类型
                disposalResult: {
                    name: '全额退款',
                    id: 40
                }, // 选中的处置类型：部分或者全部
                // returnMethodList: {
                //   province_list: {
                //     10: "监理中心垫付",
                //     20: "企业直付"
                //   }
                // }, // 退款方式
                returnMethodList: [], // 退款方式
                selectReturnMethod: {
                  name: '请选择'
                }, // 所选退货方式
                formCheckPass: true,
                Imglist: [],
                detail: {}, // 退货单详情
                flowid: 0,
                userInfo: {},
                shoppingAmount: 0, // 实际购物金额
                fileUrl: []
            };
        },
        created () {
            this.userInfo = JSON.parse(localStorage.getItem('refundUserInfo'));
            this.detail = this.$route.query.data;
            this.flowid = this.$route.query.flowid;
            this.refundAmount = this.$route.query.data.shoppingAmount;
            this.shoppingAmount = this.$route.query.data.shoppingAmount;
            this.initReturnMethods();
            this.setDictType().then(res => {
                // 不予受理原因枚举
                if (res.WHEREFORE_VERIFY && res.WHEREFORE_VERIFY.length > 0) {
                    res.WHEREFORE_VERIFY.map(item => {
                        this.reasonList.push({
                            name: item.name,
                            id: item.code
                        });
                    });
                }
            });
        },
        methods: {
            ...mapActions('refund', ['setDictType']),
            fileUploadData (val, fileUrl) {
                this.Imglist = val;
                this.fileUrl = fileUrl
                console.log('val', val)
                // console.log('fileUrl', fileUrl)
            },
            // 初始化退货方式
            initReturnMethods () {
                // 如果是企业角色只可以选择企业直付
                if (this.userInfo && this.userInfo.roleList.includes('CompanyHandler')) {
                    this.returnMethodList = [{ name: '企业退款', id: 20 }];
                    this.selectReturnMethod = { name: '企业退款', id: 20 };
                } else {
                    this.returnMethodList = [
                        { name: '企业退款', id: 20 },
                        { name: '监理中心垫付退款', id: 10 }
                    ];
                    // 如果不是监理中心时默认选中
                    if (this.userInfo && !this.userInfo.roleList.includes('Handler')) {
                      this.selectReturnMethod = { name: '监理中心垫付退款', id: 10 };
                    }
                }
            },
            // 选择退货方式回调
            selectReturnMethodHandle (item) {
                this.selectReturnMethod = item;
            },
            // 退款方式弹出框确认回调
            returnMethodConfirm (val) {
                this.returnMethodPickerShow = false;
                this.selectReturnMethod = val[0];
            },
            // 点击不予受理
            reasonHandle () {
                this.$refs['picker'].init(this.reasonItem)
            },
            // 点击不予受理原因
            selectReason (item) {
                this.reasonItem = item;
            },
            // 弹出层确认事件
            confirm (val) {
                this.disposalResult = val[0];
                if (this.disposalResult.code === 1) {
                    this.refundAmount = '';
                }
                this.show = false;
            },
            // 打开退款方式选择框
            returnMethodPickerHandle () {
                this.$refs['returnMethodPicker'].init(this.selectReturnMethod);
            },
            // 选择处置结果
            cellClick () {
                this.$refs['disposalResultPicker'].init(this.disposalResult);
            },
            selectDisposalResult (item) {
                this.disposalResult = item;
                if (item.id === 40) {
                    this.refundAmount = this.$route.query.data.shoppingAmount;
                } else {
                    this.refundAmount = '';
                }
            },
            // 提交
            onSubmit () {
                try {
           
                    // 全额退款
                    if (this.disposalResult.id == 40) {
                         if (this.selectReturnMethod.name === '请选择') {
                            return this.$toast({
                                  message: '请选择退款方式'
                              });
                          }

                            if (!this.content) {
                              return this.$Toast({
                                message: "请填写补充说明"
                              });
                            }

                      if (!this.Imglist || this.Imglist.length === 0) {
                          return this.$toast({
                              message: '请上传凭证'
                          });
                      }

                        // 如果不是不予受理的话
                        let img = this.Imglist.join(',');
                        const param = {
                            flowId: this.flowid,
                            refundType: this.selectReturnMethod.id,
                            refundAmount: this.detail.shoppingAmount,
                            content: this.content,
                            attachments: img,
                            attachId: img,
                            feedback: this.disposalResult.id,
                            attachUrl: this.fileUrl.join(',')
                        };
                        api.verify(param).then(res => {
                            if (res.ret === 0) {
                                this.$toast({
                                    message: '提交成功',
                                    icon: 'passed'
                                });
                                setTimeout(() => {
                                    this.$router.back();
                                }, 1500);
                            } else {
                                this.$Toast({
                                    message: '提交失败'
                                });
                            }
                        });
                    } else if (this.disposalResult.id == 1) {
                         if (this.selectReturnMethod.name === '请选择') {
                            return this.$toast({
                                  message: '请选择退款方式'
                              });
                          }
                        // 如果是部分退款
                        if (!this.refundAmount) {
                            return this.$Toast({
                                message: '请输入退款金额'
                            })
                        }
                        if (!this.radio && this.detail.refundChannel !== 0 && this.detail.finalRefundTypes !== 2) {
                            return this.$Toast({
                                message: '请选择是否需要退回商品'
                            })
                        }

                        if (!this.content) {
                              return this.$Toast({
                                message: "请填写补充说明"
                              });
                            }

                      if (!this.Imglist || this.Imglist.length === 0) {
                        return this.$toast({
                            message: '请上传凭证'
                        });
                    }
                        let img = this.Imglist.join(',');
                        const param = {
                            flowId: this.flowid,
                            refundType: this.selectReturnMethod.id,
                            refundAmount: this.refundAmount,
                            content: this.content,
                            attachments: img,
                            attachId: img,
                            feedback: this.disposalResult.id,
                            returnGoodsStatus: this.radio,
                            attachUrl: this.fileUrl.join(',')

                        };
                        api.verify(param).then(res => {
                            if (res.ret === 0) {
                                this.$toast({
                                    message: '提交成功',
                                    icon: 'passed'
                                });
                                setTimeout(() => {
                                    this.$router.back();
                                }, 1500);
                            } else {
                                this.$Toast({
                                    message: '提交失败'
                                });
                            }
                        });
                    } else if (this.disposalResult.id == 30) {
                        // 不予受理
                        if (this.reasonItem.name === '请选择') {
                            return this.$Toast({
                                message: '请选择不予受理原因'
                            });
                        }

                        if (!this.content) {
                              return this.$Toast({
                                message: "请填写补充说明"
                              });
                            }

                      if (!this.Imglist || this.Imglist.length === 0) {
                        return this.$toast({
                            message: '请上传凭证'
                        });
                    }
                       
                            
                            let img = this.Imglist.join(',');
                            api
                                .verify({
                                    flowId: this.flowid,
                                    content: this.content,
                                    attachments: img,
                                    attachId: img,
                                    feedback: this.disposalResult.id,
                                    wherefore: this.reasonItem.id,
                                    attachUrl: this.fileUrl.join(',')

                                })
                                .then(res => {
                                    if (res.ret === 0) {
                                        this.$toast({
                                            message: '提交成功',
                                            icon: 'passed'
                                        });
                                        setTimeout(() => {
                                            this.$router.back();
                                        }, 1500);
                                    } else {
                                        this.$Toast({
                                            message: '提交失败'
                                        });
                                    }
                                });
                    }
                } catch (err) {
                    alert(err);
                }
            },
            // 删除预览图片
            delPreImg () {
                // 没有图片是filelist是空，有内容时是一个对象
            }
        }
    };
</script>
<style lang="less" scoped>
.feedbackResult-box {
  padding: 0 16px;
  padding-bottom: 100px;
  .van-icon-arrow:before {
    font-size: 12px;
  }
  .cell-list {
    margin-bottom: 24px;
    .cell {
      padding: 24px 0;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .label {
        font-size: 14px;
        color: #666666;
        font-weight: 400;
        .xinghao {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
        }
        span {

          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
        }
      }
      /deep/.content {
        display: flex;
        align-items: center;
        .van-radio__label {
          font-size: 14px;
          color: #171a1d;
        }
        .van-radio__icon {
          display: flex;
          align-items: center;
          width: 18px;
          height: 18px;
        }
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #171A1D;
        }
        .qinguxanze {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #CCCCCC;
        }
        .arrow {
          font-size: 12px;
          vertical-align: sub;
          margin-left: 5px;
          color: #a2a3a4;
          position: relative;
          // top: -2px;
        }
      }
      /deep/.money-box {
        display: flex;
        align-items: baseline;
        .qianfuhao {
          line-height: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 10px;
          color: #242629;
        }
        .van-field__control {
          // font-family: PingFangSC-Medium;
          // font-weight: 500;
          // font-size: 14px;
          // color: #242629;
          // -webkit-text-fill-color: #242629;
        }
        .van-field__control:disabled {
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 14px;
          color: #242629;
          -webkit-text-fill-color: #242629;

        }
        .van-cell {
          max-width: 90px;
          padding: 0 0 0 3px;
          line-height: 0;
        }
      }
    }
  }
  .add {
    position: relative;
    margin-bottom: 6px;
    .title {
      font-size: 14px;
      color: #666666;
      margin-bottom: 12px;
      font-weight: 400;
      .xinghao {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #F94F4E;
        margin-left: 4px;
      }
    }
    .textarea {
      width: 100%;
      min-height: 120px;
      max-height: 320px;
      background: #f8f9fb;
      padding: 16px;
      border-radius: 4px;
      border: 0;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
    }
    .tip {
      text-align: right;
      padding-right: 16px;
      background: #f8f9fb;
      width: 100%;
      position: relative;
      top: -15px;
      font-size: 14px;
      color: #cccccc;
      border-radius: 0 0 4px 4px;
      padding-bottom: 16px;
    }
  }
  /deep/.upload-box {
    .title {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      &>span::after {
        content: '*';
        color: red;
        margin-left: 3px;
      }
    }
    .van-uploader {
      width: 80px;
      // height: 80px;
      top: 0 !important;
      width: 100%;
      .van-uploader__input-wrapper {
        border: 1px dashed #a2a3a4;
        height: 75px;
        width: 75px;
        align-items: center;
        justify-content: space-around;
        .camera-icon {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .van-icon-clear::before {
        background-size: 100% 100%;
        content: "";
        width: 18px;
        height: 18px;
        // background-image: url("../../../../assets/refund/ic_delete.png");
      }
    }
  }
  .onSubmit {
    margin-top: 35px;
    background: #36b374;
    border-radius: 4px;
    color: white;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    color: white;
  }
  .btn {
    position: fixed;
    bottom: 34px;
    background: #36b374;
    border-radius: 4px;
    color: white;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    color: white;
    width: 92%;
  }
}
</style>
